import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function DashboardScreen() {
    return html`
        <div id="dashboard-screen" class="screen" style="display: none;">
            <div class="dashboard-header">
                <h2>Welcome!</h2>
                <p id="user-email"></p>
            </div>

            <div class="journey-container">
                <div class="stats-card">
                    <div class="stat-item">
                        <div class="stat-label">Current Level</div>
                        <div class="stat-value" id="current-level">1</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-label">Experience</div>
                        <div class="stat-value" id="current-xp">0</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-label">XP to Next Level</div>
                        <div class="stat-value" id="next-level-xp">100</div>
                    </div>
                </div>

                <div class="xp-progress-container">
                    <div class="xp-progress-label">
                        <span>Level Progress</span>
                        <span id="xp-percentage">0%</span>
                    </div>
                    <div class="xp-progress-bar">
                        <div class="xp-progress-fill" id="xp-progress-fill"></div>
                    </div>
                </div>

                <div class="journey-path-container">
                    <svg class="journey-path-svg" viewBox="0 0 300 1200" preserveAspectRatio="xMidYMin slice">
                        <path
                            id="journey-path"
                            d="M 150 50 Q 80 150 150 250 T 150 450 T 150 650 T 150 850 T 150 1050"
                            fill="none"
                            stroke="#E2E8F0"
                            stroke-width="8"
                            stroke-linecap="round"
                        />
                        <path
                            id="journey-path-progress"
                            d="M 150 50 Q 80 150 150 250 T 150 450 T 150 650 T 150 850 T 150 1050"
                            fill="none"
                            stroke="url(#gradient)"
                            stroke-width="8"
                            stroke-linecap="round"
                            stroke-dasharray="0 2000"
                        />
                    </svg>

                    <div class="badge-container">
                        <div class="level-badge" data-level="1" style="top: 50px; left: 50%;">
                            <div class="badge-circle unlocked">
                                <span class="badge-level">1</span>
                            </div>
                            <div class="badge-label">Beginner</div>
                        </div>
                        <div class="level-badge" data-level="2" style="top: 150px; left: 30%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">2</span>
                            </div>
                            <div class="badge-label">Learner</div>
                        </div>
                        <div class="level-badge" data-level="3" style="top: 250px; left: 50%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">3</span>
                            </div>
                            <div class="badge-label">Explorer</div>
                        </div>
                        <div class="level-badge" data-level="4" style="top: 350px; left: 70%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">4</span>
                            </div>
                            <div class="badge-label">Adept</div>
                        </div>
                        <div class="level-badge" data-level="5" style="top: 450px; left: 50%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">5</span>
                            </div>
                            <div class="badge-label">Scholar</div>
                        </div>
                        <div class="level-badge" data-level="6" style="top: 550px; left: 30%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">6</span>
                            </div>
                            <div class="badge-label">Expert</div>
                        </div>
                        <div class="level-badge" data-level="7" style="top: 650px; left: 50%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">7</span>
                            </div>
                            <div class="badge-label">Master</div>
                        </div>
                        <div class="level-badge" data-level="8" style="top: 750px; left: 70%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">8</span>
                            </div>
                            <div class="badge-label">Sage</div>
                        </div>
                        <div class="level-badge" data-level="9" style="top: 850px; left: 50%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">9</span>
                            </div>
                            <div class="badge-label">Virtuoso</div>
                        </div>
                        <div class="level-badge" data-level="10" style="top: 950px; left: 30%;">
                            <div class="badge-circle locked">
                                <span class="badge-level">10</span>
                            </div>
                            <div class="badge-label">Legend</div>
                        </div>
                    </div>

                    <svg style="width:0; height:0; position:absolute;">
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color:#6C63FF;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#00F5D4;stop-opacity:1" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>

                <div class="xp-controls">
                    <button class="btn btn-primary" id="add-xp-btn">+ Add 50 XP</button>
                </div>
            </div>

            <button id="logout-btn" class="btn btn-secondary" style="display: none;">Logout</button>
        </div>
    `;
}
